const thrpyBillingTransactionType = {
  UnSet: 0,
  Visit: 1,
  Appointment: 2,
  VisitRP: 3,
  Consulting: 4,
  Educational: 8,
};

export default thrpyBillingTransactionType;
